export const getTimeBasedGreeting = () => {
  const hour = new Date().getHours();
  
  if (hour >= 5 && hour < 12) {
    return { greeting: 'Good morning', icon: 'sunrise' };
  } else if (hour >= 12 && hour < 17) {
    return { greeting: 'Good afternoon', icon: 'sun' };
  } else if (hour >= 17 && hour < 21) {
    return { greeting: 'Good evening', icon: 'sunset' };
  } else {
    return { greeting: 'Good night', icon: 'moon' };
  }
};
